ACC.favorites = {
    _autoload: [
        "addToFavorite",
        "disableAddlistInput",
        ["bindDeleteFavoriteListLink", $('.js-delete-favorite-list').length !== 0],
        ["bindDeleteConfirmLink", $('.js-favoritelist_delete_confirm').length !== 0],
        ["bindSetDefaultList", $('.js-favorite-default-list').length !== 0],
        ["editInfoFavoriteList", $('.js-editFavoriteInfo').length !== 0],
        ["changeDefaultList", $('#default-list-choice').length !== 0],
        ["editFavoriteAction", $('#editFavoriteAction').length !== 0],
        ["showStoreFinderPopinInFavorite", $('.showStoreFinderPopinInFavorite').length !== 0],
        "showFavoriteProductQty",
        "addToCartQty",
        ["addAllListToCart", $('.js-favoritelistAddAll').length !== 0],
        ["handleQtSelector", $('.list-favorite-product').length !== 0],
    ],

    $savedCartRestoreBtn: {},
    $currentCartName: {},
    openedModalProductCode: "",

    addToFavorite: function () {
        this._bindModal('.addToFavorite', '#ct-favorites', {
            onOpen: () => {
                $('#ct-favorites').show();
                $(".favorites-list").perfectScrollbar({useBothWheelAxes: false, suppressScrollX: true});
            },
            onComplete: () => this._handleFavoriteListInput()
        });
    },

    disableAddlistInput: function () {
        const inputText = $('.new-list input[type=text]');
        $('#addToFavoriteForm').on('change', 'input[type=radio]', () => {
            inputText.prop('disabled', !$('.newlist__radio').is(':checked')).focus();
        });
    },

    bindDeleteFavoriteListLink: function () {
        this._bindModalClick('.js-delete-favorite-list', (element) => {
            return {
                inline: true,
                className: "js-favoritelist_delete_confirm_modal",
                href: "#popup_confirm_favoritelist_delete_" + element.data('favoritelist-id'),
                width: '500px'
            };
        });
    },

    bindSetDefaultList: function () {
        $(document).on("click", '.js-favorite-default-list', function () {
            const url = `${ACC.config.setDefaultListFavorite}/?favoriteListName=${$(this).val()}&isDefault=${$(this).prop('checked')}`;
            $.ajax({url, type: 'GET'});
        });
    },

    bindDeleteConfirmLink: function () {
        this._bindAjaxClick('.js-favoritelist_delete_confirm', (element) => ({
            url: `${ACC.config.encodedContextPath}/my-account/my-favorites/${element.data('favoritelist-id')}/delete`,
            type: 'DELETE',
            success: () => {
                ACC.colorbox.close();
                window.location.replace(`${ACC.config.encodedContextPath}/my-account/my-favorites`);
            }
        }));

        $(document).on("click", '.js-favoritelist_delete_confirm_cancel', ACC.colorbox.close);
    },

    editInfoFavoriteList: function () {
        this._bindModal('.js-editFavoriteInfo', '#editFavoriteInfo', {
            onOpen: () => {
                $('#editFavoriteInfo').show();
                $('#nameListFavorit').val($('.favoriteListName').html());
                $('#descriptionArea').val($('.favoriteListDescription').html());
            },
            onComplete: () => {
                $('#default-list-choice').prop('checked', $('#defaultList').is(':checked'));
                $('#hiddenInputIsdefault').val($('#defaultList').is(':checked'));
                $('#editFavoriteForm input[type=text]').removeClass('error');
                $('#editFavoriteInfo .help_error, #editFavoriteInfo .empty_error').hide();
            }
        });
    },

    changeDefaultList: function () {
        $('#default-list-choice').on('change', function () {
            $('input[name="defaultList"]').val($(this).prop('checked'));
        });
    },

    editFavoriteAction: function () {
        $('#editFavoriteAction').on('click', function (e) {
            e.preventDefault();
            const inputTxt = $('#editFavoriteForm input[type=text]');
            if (!inputTxt.val().length) {
                $('.empty_error').show().siblings('.help_error').hide();
                inputTxt.addClass('error');
            } else {
                inputTxt.removeClass('error');
                $('.empty_error').hide();
                $.ajax({
                    url: `${ACC.config.encodedContextPath}${$('#editFavoriteInfo').data('url-edit')}`,
                    type: 'POST',
                    data: $('#editFavoriteForm').serialize(),
                    success: (response) => {
                        const obj = JSON.parse(response);
                        if (obj.result === 'ok') {
                            window.location.replace(`${ACC.config.encodedContextPath}/my-account/my-favorites/${$('#nameListFavorit').val()}`);
                        } else {
                            $('#editFavoriteInfo .help_error').html(obj.data.message).show();
                            inputTxt.addClass('error');
                        }
                    }
                });
            }
        });
    },

    showStoreFinderPopinInFavorite: function () {
        $('.showStoreFinderPopinInFavorite').on('click', function (e) {
            e.preventDefault();
            ACC.storefinderPopin.openStoreFinderPopinModal(true);
        });
    },

    showFavoriteProductQty: function (popinQtyTitle, productCode, open) {
        if (open) {
            ACC.colorbox.open(popinQtyTitle, {
                inline: true,
                className: "js-favoritelist_product_qty_modal",
                href: `#popin_favoritelist_product_qty_${productCode}`,
                width: '320px',
                onComplete: () => $('.favoriteProductQty').focus()
            });
            ACC.favorites.openedModalProductCode = productCode;
        }
    },

    addToCartQty: function () {
        $(document).on("click", '.js-favoritelist_product_qty_modal_validate', function (e) {
            e.preventDefault();
            let modalId = `#popin_favoritelist_product_qty_${ACC.favorites.openedModalProductCode}`,
                favoriteProductQtyInput = $(`${modalId} .favoriteProductQty`),
                favoriteProductQty = $.trim(favoriteProductQtyInput.val());

            if (Math.floor(favoriteProductQty) === favoriteProductQty && $.isNumeric(favoriteProductQty)) {

                ACC.favorites.resetQtyPopup(favoriteProductQtyInput, $(`${modalId} .favoriteProductQtyError`));
                $.post($('#addToCartProductUrl').val(), {
                    productCode: $(this).closest(modalId).find('input[name=productCode]').val(),
                    qty: favoriteProductQty
                }, (data) => {
                    ACC.colorbox.close();
                    ACC.product.displayAddToCartPopup(data);
                });
            } else {
                favoriteProductQtyInput.addClass('errorRedBorder').next('.favoriteProductQtyError').css('opacity', '1');
            }
        });
    },

    resetQtyPopup: function (input, inputError) {
        input.removeClass('errorRedBorder').val('');
        inputError.css('opacity', '0');
    },

    oopsPopup: function (content) {
        ACC.colorbox.open($('#oupsText').val(), {html: content, width: "460px"});
    },

    addAllListToCart: function () {
        $(document).on("click", '.js-favoritelistAddAll', function (e) {
            e.preventDefault();
            ACC.product.showLoader();
            $(this).find('span').text(ACC.btnValidatedText);
            $.ajax({
                url: $('#addToCartProductsUrl').val(),
                type: 'POST',
                data: {products: extractProductsData()},
                success: function () {
                    if (typeof ACC.minicart.updateMiniCartDisplay === 'function') {
                        ACC.minicart.updateMiniCartDisplay();
                    }

                    $('.alert').find('span').text(ACC.config.updateCartMessage).end().removeClass('display-none');
                },
                complete: function (jqXHR, textStatus) {
                    $('.js-favoritelistAddAll').find('span').text(ACC.btnDefaultAddAllToListTxt);
                    $('.modal-loader').remove();
                }
            });
        });

        function extractProductsData() {
            let productsArray = [];

            let filledInputs = $('.favoriteProductQty').map(function () {
                let productCode = $(this).data('product-code'),
                    inputValue = $(this).val().trim();
                return inputValue !== '' ? `${productCode}:${inputValue}` : null;
            }).get();

            if (filledInputs.length > 0) {
                return filledInputs.join(';');
            }

            return $('.favoriteProductQty').map(function () {
                return `${$(this).data('product-code')}:1`;
            }).get().join(';');
        }


    },

    handleQtSelector: function () {
        let $container = $('.list-favorite-product');
        $container.on('input', '.qty-selector', function () {
            let $input = $(this),
                qty = $input.val().trim(),
                $addToCartBtn = $input.closest('li').find('.js-add-favorite-to-cart');

            $addToCartBtn.toggleClass('disabled gray-btn', !qty || $input.val() == 0).prop('disabled', !qty);
            if (qty.length > 4) $input.val(qty.slice(0, 4));
        }).on('click', '.js-add-favorite-to-cart', function (e) {
            e.preventDefault();
            let _input = $(this);
            _input.find('span').text(ACC.btnValidatedText);
            let $addToCartBtn = $(this), $input = $addToCartBtn.closest('li').find('.qty-selector'),
                qty = $input.val().trim();
            if (!isNaN(qty) && qty >= 1) {
                $.post($input.data('url'), {productCode: $input.data('product-code'), qty})
                    .done((data) => {
                        ACC.product.displayAddToCartPopup(data);
                        $input.val('');
                        _input.find('span').text(ACC.btnDefaultAddToCartText);
                        $addToCartBtn.addClass('disabled gray-btn').prop('disabled', true);
                    })
                    .fail((jqXHR, textStatus, errorThrown) => console.error('Erreur lors de l\'ajout au panier :', textStatus, errorThrown));
            }
        });
    },

    _bindModal: function (selector, target, options) {
        $(selector).on('click', function (e) {
            e.preventDefault();
            $.colorbox({
                href: target,
                maxWidth: "100%",
                width: 525,
                opacity: 0.7,
                inline: true,
                title: $(`${target} .headline`).html(),
                close: '<span class="glyphicon glyphicon-remove"></span>',
                onOpen: () => $(target).show(),
                onComplete: options.onComplete,
                onCleanup: () => $(target).hide()
            });
        });
    },

    _bindModalClick: function (selector, optionsBuilder) {
        $(document).on("click", selector, function (event) {
            event.preventDefault();
            ACC.colorbox.open($(this).data('delete-popup-title'), optionsBuilder($(this)));
        });
    },

    _bindAjaxClick: function (selector, optionsBuilder) {
        $(document).on("click", selector, function (event) {
            event.preventDefault();
            $.ajax(optionsBuilder($(this)));
        });
    },

    _handleFavoriteListInput: function () {
        const input = $('input[name=newFavoriteListName]');
        input.bind('keypress', function (e) {
            const k = e.which;
            if (!(k >= 65 && k <= 90 || k >= 97 && k <= 122 || k == 252 || k == 220 || k == 228 || k == 196 || k == 246 || k == 214 || k == 223 || k >= 48 && k <= 57 || k == 32)) {
                e.preventDefault();
            }
        }).bind('change paste keyup', function () {
            input.val(input.val().replace(/[^a-zäöüÄÖÜß0-9\s]/gi, ''));
        });
    }
};